import { h, Fragment } from 'preact';
import { Dialog, Transition } from '@headlessui/react';
import { decodeHtml } from '../lifesharp-hero/utils';

export const CartClearWarningModal = ({
  onContinue,
  onCancel,
  isOpen,
  setIsOpen,
  warningTitle = decodeHtml(
    window.TMW.Strings.lifesharp.warningModal.warningTitle,
  ),
  warningText = decodeHtml(
    window.TMW.Strings.lifesharp.warningModal.warningText,
  ),
}) => {
  const handleClose = () => setIsOpen(false);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full transform overflow-hidden bg-white px-5 tablet:px-[2.1875rem] pt-[3.125rem] tablet:pt-[3.75rem] pb-5 tablet:pb-10 text-left align-middle shadow-xl transition-all max-w-[30rem]">
                <Dialog.Title
                  as="h3"
                  className="text-base leading-5 tablet:text-[1.375rem] font-black tablet:leading-[1.625rem] uppercase mb-[0.875rem] w-[16rem] font-gotham"
                >
                  {warningTitle}
                </Dialog.Title>

                <CloseButton onClick={handleClose} />

                <p className="text-sm font-book tablet:mr-[1.4375rem] font-gotham">
                  {warningText}
                </p>

                <div className="mt-4 flex justify-between gap-3">
                  <ActionButton
                    onClick={onContinue}
                    isPrimary
                    text={window.TMW.Strings.lifesharp.warningModal.continue}
                  />
                  <ActionButton
                    onClick={onCancel}
                    text={window.TMW.Strings.lifesharp.warningModal.cancel}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

const CloseButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="absolute top-[1.4375rem] tablet:top-[2.0625rem] right-[1.4375rem] tablet:right-[2.0625rem] text-accent-1"
    aria-label={window.TMW.Strings.lifesharp.warningModal.closeDialog}
  >
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 17.3666L16.6667 3.47332"
        stroke="#FF5200"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.33333 3.47331L16.6667 17.3666"
        stroke="#FF5200"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </button>
);

const ActionButton = ({ onClick, isPrimary = false, text }) => (
  <button
    type="button"
    className={`flex-1 justify-center text-xs font-bold font-gotham h-[3.125rem] uppercase ${
      isPrimary ? 'bg-black text-white' : 'border-black border'
    }`}
    onClick={onClick}
  >
    {text}
  </button>
);

export default CartClearWarningModal;
